export const locationIntradaySelectOptions = {
  options: {
    revenueCenterMetrics: {
      defaultId: [['all', 'average_net_sales|price']],
      options: [
        // All revenue centers
        { id: 'all', parentId: 'root', displayName: 'All' },
        {
          id: 'average_net_sales|price',
          parentId: 'all',
          displayName: 'Average Sales',
        },
        {
          id: 'average_check_count|number',
          parentId: 'all',
          displayName: 'Average Check Count',
        },
        {
          id: 'average_labor_cost|price',
          parentId: 'all',
          displayName: 'Labor $',
        },
        {
          id: 'average_labor_hour|number',
          parentId: 'all',
          displayName: 'Average Labor Hours',
        },
        {
          id: 'average_labor_percent|percent',
          parentId: 'all',
          displayName: 'Average Labor %',
        },
        {
          id: 'splh|price',
          parentId: 'all',
          displayName: 'SPLH',
        },
        {
          id: 'average_sales_minus_labor_cost|price',
          parentId: 'all',
          displayName: 'Average Sales $ - Labor $',
        },

        {
          id: 'take_out',
          parentId: 'root',
          displayName: 'Take Out',
        },
        {
          id: 'average_revenue_center_sales_take_out|price',
          parentId: 'take_out',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_take_out|number',
          parentId: 'take_out',
          displayName: 'Average Check Count',
        },

        {
          id: 'drive_thru',
          parentId: 'root',
          displayName: 'Drive Thru',
        },
        {
          id: 'average_revenue_center_sales_drive_thru|price',
          parentId: 'drive_thru',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_drive_thru|number',
          parentId: 'drive_thru',
          displayName: 'Average Check Count',
        },

        {
          id: 'eat_in',
          parentId: 'root',
          displayName: 'Eat In',
        },
        {
          id: 'average_revenue_center_sales_eat_in|price',
          parentId: 'eat_in',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_eat_in|number',
          parentId: 'eat_in',
          displayName: 'Average Check Count',
        },

        {
          id: 'web_take_out',
          parentId: 'root',
          displayName: 'Web Take Out',
        },
        {
          id: 'average_revenue_center_sales_web_take_out|price',
          parentId: 'web_take_out',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_web_take_out|number',
          parentId: 'web_take_out',
          displayName: 'Average Check Count',
        },

        {
          id: 'web_3rd_app',
          parentId: 'root',
          displayName: 'Web 3rd App',
        },
        {
          id: 'average_revenue_center_sales_web_3rd_app|price',
          parentId: 'web_3rd_app',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_web_3rd_app|number',
          parentId: 'web_3rd_app',
          displayName: 'Average Check Count',
        },

        {
          id: 'web_delivery',
          parentId: 'root',
          displayName: 'Web Delivery',
        },
        {
          id: 'average_revenue_center_sales_web_delivery|price',
          parentId: 'web_delivery',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_web_delivery|number',
          parentId: 'web_delivery',
          displayName: 'Average Check Count',
        },
      ],
    },
    dayOfWeek: {
      defaultId: [
        ['dow1'],
        ['dow2'],
        ['dow3'],
        ['dow4'],
        ['dow5'],
        ['dow6'],
        ['dow7'],
      ],
      options: [
        { id: 'dow1', parentId: 'root', displayName: 'Monday' },
        { id: 'dow2', parentId: 'root', displayName: 'Tuesday' },
        { id: 'dow3', parentId: 'root', displayName: 'Wednesday' },
        { id: 'dow4', parentId: 'root', displayName: 'Thursday' },
        { id: 'dow5', parentId: 'root', displayName: 'Friday' },
        { id: 'dow6', parentId: 'root', displayName: 'Saturday' },
        { id: 'dow7', parentId: 'root', displayName: 'Sunday' },
      ],
    },
    hours: {
      defaultId: [
        ['hour2100'],
        ['hour2200'],
        ['hour2300'],
        ['hour2400'],
        ['hour2500'],
        ['hour2600'],
      ],
      options: [
        // All hours
        { id: 'hour900', parentId: 'root', displayName: '9am-10am' },
        { id: 'hour1000', parentId: 'root', displayName: '10am-11am' },
        { id: 'hour1100', parentId: 'root', displayName: '11am-12pm' },
        { id: 'hour1200', parentId: 'root', displayName: '12pm-1pm' },
        { id: 'hour1300', parentId: 'root', displayName: '1pm-2pm' },
        { id: 'hour1400', parentId: 'root', displayName: '2pm-3pm' },
        { id: 'hour1500', parentId: 'root', displayName: '3pm-4pm' },
        { id: 'hour1600', parentId: 'root', displayName: '4pm-5pm' },
        { id: 'hour1700', parentId: 'root', displayName: '5pm-6pm' },
        { id: 'hour1800', parentId: 'root', displayName: '6pm-7pm' },
        { id: 'hour1900', parentId: 'root', displayName: '7pm-8pm' },
        { id: 'hour2000', parentId: 'root', displayName: '8pm-9pm' },
        { id: 'hour2100', parentId: 'root', displayName: '9pm-10pm' },
        { id: 'hour2200', parentId: 'root', displayName: '10pm-11pm' },
        { id: 'hour2300', parentId: 'root', displayName: '11pm-12am' },
        { id: 'hour2400', parentId: 'root', displayName: '12am-1am' },
        { id: 'hour2500', parentId: 'root', displayName: '1am-2am' },
        { id: 'hour2600', parentId: 'root', displayName: '2am-3am' },
      ],
    },
  },
}

export function getRevenueCenterMetricDisplayName(metricId: string) {
  const allRevenueCenterOptions =
    locationIntradaySelectOptions.options.revenueCenterMetrics.options
  const selectedOption = allRevenueCenterOptions.find(
    (option) => option.id === metricId,
  )
  return selectedOption?.displayName || ''
}
